import {PromoApplied} from '../promo-codes/types'
import {StoreQuoteLine} from './index'

export type CartPromoLine = {covered: boolean; promoDiscount: number; payableAfter: number} | null

export type CartPromoView = {
  // One entry per cart line, same order; null when the server did not say (an older server, no code).
  lines: CartPromoLine[]
  // Names of the products the code covers, once each.
  coveredNames: string[]
  // "−15%" for a percent code; null for a fixed amount (the line shows its own saving).
  tag: string | null
}

// What the applied code does to each cart line, from the quote's per-line result (server #3633).
export const cartPromoView = (
  cartLines: {name: string}[],
  quoteLines: StoreQuoteLine[] | undefined,
  applied: PromoApplied | null,
): CartPromoView => {
  const known = Boolean(applied && quoteLines && quoteLines.length === cartLines.length)
  const lines: CartPromoLine[] = cartLines.map((_, i) => {
    const q = known && quoteLines ? quoteLines[i] : undefined
    return q
      ? {covered: q.eligible && q.promoDiscount > 0, promoDiscount: q.promoDiscount, payableAfter: q.payableAfter}
      : null
  })
  const coveredNames = Array.from(new Set(cartLines.filter((_, i) => lines[i]?.covered).map((line) => line.name)))
  const tag = applied && applied.discountType === 'PERCENT' ? `−${applied.discount}%` : null
  return {lines, coveredNames, tag}
}
